import * as React from 'react';
import {Scrollbar, ScrollbarProperties} from '@priority-software/priority-style-react';
import {useScroll} from '../../hooks/dropdown/useScroll';

export interface ItemsListProps extends ScrollbarProperties {
    items: Array<any>;
    renderItem(item): JSX.Element;
    keyExtractor?: (item, idx?) => string;
    itemProps?: any;
    /** use to send props other than data that shoud effect list rerender */
    extraData?: any;
    isItemSelected?: any;
    focusedIndex?: number;
}

export const ItemsList = React.memo((props: ItemsListProps) => {
    const {itemsRef} = useScroll({items: props.items, focusedItemIndex: props.focusedIndex});
    const {
        items,
        keyExtractor,
        renderItem: Item,
        itemProps,
        isItemSelected,
        focusedIndex,
        ...scrollProps
    } = props;

    return (
        <Scrollbar {...scrollProps}>
            {items.map((item, idx) => {
                const key = keyExtractor ? keyExtractor(item, idx) : idx;
                return (
                    <Item
                        item={item}
                        index={idx}
                        key={key}
                        ref={itemsRef.current[idx]}
                        isSelected={isItemSelected?.(item)}
                        isFocused={focusedIndex === idx}
                        {...itemProps}
                    />
                );
            })}
        </Scrollbar>
    );
});
